/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { type WithTokenItemRequestBuilder, WithTokenItemRequestBuilderNavigationMetadata, WithTokenItemRequestBuilderRequestsMetadata } from './item/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /shares/revisions
 */
export interface RevisionsRequestBuilder extends BaseRequestBuilder<RevisionsRequestBuilder> {
    /**
     * Gets an item from the ApiSdk.shares.revisions.item collection
     * @param token Unique identifier of the item
     * @returns {WithTokenItemRequestBuilder}
     */
     byToken(token: string) : WithTokenItemRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const RevisionsRequestBuilderUriTemplate = "{+baseurl}/shares/revisions";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const RevisionsRequestBuilderNavigationMetadata: Record<Exclude<keyof RevisionsRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byToken: {
        requestsMetadata: WithTokenItemRequestBuilderRequestsMetadata,
        navigationMetadata: WithTokenItemRequestBuilderNavigationMetadata,
        pathParametersMappings: ["token"],
    },
};
/* tslint:enable */
/* eslint-enable */
